<template>
  <div>
    <PageTitle :title="$t('global.my-info')" />
    <div class="row">
      <div class="col-md-6 mb-4">
        <Card title="Basic Information">
          <UserInfoForm />
        </Card>
      </div>
      <div class="col-md-6 mb-4">
        <Card title="Security Settings">
          <UserSecurityForm />
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import Card from "@/components/display/Card";
import PageTitle from "@/components/display/PageTitle";
import UserInfoForm from "@/components/smart/forms/UserInfoForm";
import UserSecurityForm from "@/components/smart/forms/UserSecurityForm";

export default {
  name: "MyInfoPage",
  components: {
    Card,
    PageTitle,
    UserSecurityForm,
    UserInfoForm,
  },
  setup() {
    const loading = ref(false);
    onMounted(() => {
      // todo
    });
    return {
      loading,
    };
  },
};
</script>
